import * as styles from './index.module.scss';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';

// import AnimationButton from '../../../components/animationButton';
// import dayjs from 'dayjs';
// import ArrowRightIcon from '@/components/icons/arrowRight';
// import { ArrowRightOutlined } from '@ant-design/icons';
import { navigate } from 'gatsby';
import ROUTER_PATH from '@/constants/router';
// import { useNodeCountDown } from '@/hooks';
// import Chart from 'react-apexcharts';

const Index = () => {
  // const { days, hours, minutes, seconds, isFinished } = useNodeCountDown();
  // const formatTime = (time: number) => String(time).padStart(2, '0');
  return (
    <div className={styles.banner} id="banner">
      <div className={styles.content}>
        <div className={styles.left}>
          <div className={styles.title}>
            Run a Node <br />
            To mine <span>MTTs</span>
          </div>
          <div className={styles.desc}>
            MTT network is built on the{' '}
            <img
              src="https://cdn-web.mtt.xyz/static/Frame%201410078297.png"
              alt=""
            />
            &nbsp;
            <span>Cosmos SDK</span>
            <br />
            and compatible with{' '}
            <img
              src="https://cdn-web.mtt.xyz/static/Frame%20427320914.png"
              alt=""
            />{' '}
            <span> EVM.</span>
            <br />
            Especially designed for <span> E-sports tournaments.</span>
          </div>
          {/* {isFinished ? ( */}
          <div
            className={styles.nodeButton}
            onClick={() => navigate(ROUTER_PATH.Node)}
          >
            <label>Direct to Nodes</label>
            <div className={styles.right}>
              <div className={styles.rightBg}></div>
              <StaticImage
                src="https://static-s3.mtt.xyz/chain-website/3f9167be81d386786137bb31c6a97986.png"
                alt="arrow"
                className={styles.icon}
              />
            </div>
          </div>
          {/* ) : ( */}
          {/* <div className={styles.timeSection}> */}
          {/* <AnimationButton className={styles.connetButton} type="primary">
              Connect Wallet
            </AnimationButton>
            <AnimationButton className={styles.contactButton}>
              Contact Us
            </AnimationButton> */}
          {/* <div className={styles.days}>
                <span>{formatTime(days)}</span>
                <label>DAYS</label>
              </div>
              <div>
                <span>{formatTime(hours)}</span>
                <label>HOUR</label>
              </div>
              <div>
                <span>{formatTime(minutes)}</span>
                <label>MIN</label>
              </div>
              <div>
                <span>{formatTime(seconds)}</span>
                <label>SEC</label>
              </div>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default Index;
